<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="170px">
      <el-form-item
        label="图标"
        required
        :rules="{ required: true, message: '请上传图标', trigger: 'change' }"
        prop="icon"
      >
        <uploadImg v-model="form.icon" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入标题" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item label="成长币数量" prop="creditCount">
        <el-input type="text" placeholder="请输入成长币数量" clearable v-model="form.creditCount" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item label="首充优惠" prop="firstCharge">
        <el-radio-group v-model="form.firstCharge">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="首充图标"
        required
        :rules="{ required: true, message: '请上传首充图标', trigger: 'change' }"
        prop="firstIcon2"
        v-if="form.firstCharge == 1"
      >
        <uploadImg v-model="form.firstIcon" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="首充数量" prop="firstCreditCount" v-if="form.firstCharge == 1">
        <el-input type="text" placeholder="请输入首充数量" clearable v-model="form.firstCreditCount" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item label="金额" prop="price">
        <el-input type="text" placeholder="请输入金额" clearable v-model="form.price" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input type="text" placeholder="请输入排序" clearable v-model="form.sort" style="width:400px"></el-input>
      </el-form-item>
    </el-form>
    <div class="footer" v-if="!editorialJudgment">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">确 定</el-button>
    </div>
    <div class="footer" v-if="editorialJudgment">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getModify('form')">确 定</el-button>
    </div>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import uploadImg from '@/components/uploadImage/index.vue'
import {
  addGrowthCoin,
  updateGrowthCoinDetail,
  getGrowthCoinDetail
} from '@/api/demo/GrowthCoin/index'
export default {
  components: {
    uploadImg
  },
  name: 'addGrowthCoin',
  data () {
    return {
      radio: '1',
      tableKey: 0,
      form: {
        icon: '', // 图标
        icon2: [],
        name: null, // 名称
        price: null, // 金额
        sort: '', // 排序
        firstIcon2: [],
        firstIcon: '',
        firstCharge: null, // 是否首充
        firstCreditCount: ''// 首充数量
      },
      rules: {
        creditCount: [
          {
            required: true,
            message: '请输入成长币数量',
            trigger: 'blur'
          }
        ],
        price: [
          {
            required: true,
            message: '请输入金额',
            trigger: 'blur'
          }
        ],
        sort: [
          {
            required: true,
            message: '请输入排序',
            trigger: 'blur'
          }
        ],
        firstCharge: [
          {
            required: true,
            message: '请选择是否首充',
            trigger: 'change'
          }
        ],
        firstCreditCount: [
          {
            required: true,
            message: '请输入首充数量',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ]
      },
      editorialJudgment: false // 判断新增或者编辑
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  created () {
    let that = this
    this.getId = this.$route.query.id
    if (this.getId != undefined) {
      that.editorialJudgment = true
      that.getListArr()
    } else if (this.getId == undefined) {
      that.editorialJudgment = false
    }
  },
  mounted () {},
  methods: {
    getListArr () {
      let that = this
      getGrowthCoinDetail(that.getId).then(res => {
        that.form = res
      })
    },
    // 新增
    getCreate (formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          addGrowthCoin(this.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/GrowthCoin')
          })
        }
      })
    },
    // 编辑确定
    getModify (formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          updateGrowthCoinDetail(this.getId, this.form).then(res => {
            that.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/GrowthCoin')
          })
        }
      })
    },
    // 取消
    cancel (formName) {
      this.$router.push('/demo/GrowthCoin')
    }
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
  margin-top: 30px;
}
.el-dialog__footer {
  display: flex;
}
</style>
